let isElectron = window && window.process && window.process.type && window.require
const userAgent = navigator.userAgent
const isOpera = userAgent.indexOf('Opera') > -1
const isIE = userAgent.indexOf('compatible') > -1 && userAgent.indexOf('MSIE') > -1 && !isOpera
const isEdge = userAgent.indexOf('Edge') > -1
const isFF = userAgent.indexOf('Firefox') > -1
const isSafari = userAgent.indexOf('Safari') > -1 && userAgent.indexOf('Chrome') === -1
const isChrome = userAgent.indexOf('Chrome') > -1 && userAgent.indexOf('Safari') > -1

export default {
  isElectron,

  getDeviceType () {
    // 桌面端
    if (isElectron) {
      return 'client'
    } else {
      // 律师端
      if (location.hostname === process.env.VUE_APP_DOMAIN) {
        return 'web'
      } else {
      // 律师跳转企业端
        return 'lawyer-to-company'
      }
    }
  },
  openWindow (params, openInBroswer = false) {
    if (isElectron && openInBroswer) {
      let ipc = window.require('electron').ipcRenderer
      ipc.send('open-external', { url: params.url })
      return {
        location: ''
      }
    } else {
      return window.open(params && params.url)
    }
  },
  filePreviewWindow (params) {
    let route = {
      name: 'filePreviewWindow',
      query: params
    }
    let rootApp = window.rootApp
    const { href } = rootApp.$router.resolve(route)
    window.open(href, '_blank')
  },
  isEdge,
  isIE,
  isFF,
  isSafari,
  isChrome,
  isOpera
}
